// extracted by mini-css-extract-plugin
export var conversationListItem = "_x2-2";
export var fullBleedList = "_x2-3";
export var messageText = "_x2-1";
export var previewText = "_x2-0";